<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">STATISTIQUES</h1>
      <h2
        class="center__text">
        Accédez à toutes les statistiques essentielles pour optimiser vos campagnes
  
      </h2>
      <h2>Analysez les statistiques de vos campagnes</h2>
      <p>
        Observez instantanément toutes vos statistiques SMS en un clic.
        Analysez vos envois selon l'année, le mois ou le jour, avec des
        présentations graphiques pour faciliter la compréhension des données.
      </p>
      <h2>Consultez l'historique de vos campagnes passées</h2>
      <p>
        servicesms.sn conserve un historique complet de toutes vos campagnes,
        incluant les dates, les messages, les réponses, les SMS et les statuts des accusés de réception.
      </p>
      <h2>Recevez des accusés de réception pour vos envois</h2>
      <p>
        Optimisez votre liste de contacts en analysant les accusés de réception.
         Exportez facilement les numéros erronés.
      </p>
      <h2>Téléchargez les réponses reçues</h2>
      <p>
        Accédez facilement aux réponses liées à une campagne 
        et téléchargez-les pour une consultation ultérieure.
      </p>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";

export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

</script>
<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
